import $ from 'jquery'

window.addEventListener('load', function() {
    if(location.protocol=='https:') {
        if (window.location.pathname === '/piskotki' || window.location.pathname === '/piskotki/') {
            $.support.cors = true;
            showNoticeCookiesPage();

            $('input').click(function() {
                setSelectedCookies();
            });

            $(".cookieconsent_container__ok").click(function() {
                $('.notice').css('display', 'block');
                $(".cookieconsent_container__ok").addClass('hidden');
                $(".cookieconsent_container__mandatory").addClass('hidden');
                setCheckboxes();
            });

            $(".cookieconsent_container__mandatory").click(function() {
                $('.notice').css('display', 'block');
                $(".cookieconsent_container__mandatory").addClass('hidden');
                setCheckboxes();
            });

            $(".cookieconsent_container__restrict").click(function() {
                $(".notice").addClass('hidden');
                setCheckboxes();
                if (typeof checkCookie !== 'undefined' && !checkCookie("analiticni-oglasevalski-druzabni")) {
                    $(".cookieconsent_container__ok").removeClass('hidden');
                    $(".cookieconsent_container__mandatory").addClass('hidden');
                } else {
                    $(".cookieconsent_container__ok").addClass('hidden');
                    $(".cookieconsent_container__mandatory").addClass('hidden');
                }
            });

            $(".cookieconsent_container__back").click(function() {
                window.location.href = getBackUrl();
            });
        } else {
            showNotice();
        }
    }
})

function showNotice() {

    if (!window.location.pathname.includes('/piskotki'))
        return

    $(".notice").addClass('hidden');
    //ce cookie ne obstaja, prikazi normalno obvestilo
    if (getCookie("ALLOW_COOKIES") == null || checkCookie("brez") || checkCookie("nujni")) {
        $(".notice").addClass('annoying').removeClass('friendly hidden');
    }
}

export function showNoticeCookiesPage() {

    $(".notice").addClass('hidden');
    if (getCookie("ALLOW_COOKIES") == null || checkCookie("brez") || checkCookie("nujni")) {
        $(".notice").removeClass('annoying hidden').addClass('friendly');
        $(".cookieconsent_container__more").addClass('hidden');
        $(".cookieconsent_container__mandatory").removeClass('hidden');
        $(".cookieconsent_container__restrict").removeClass('hidden');
    }

    else {
        if ( typeof checkCookie !== 'undefined' //ce cookie obstaja, vendar nima vseh opcij potrjenih
            && !checkCookie("analiticni-oglasevalski-druzabni")) {
            $(".notice").removeClass('annoying hidden').addClass('friendly');
            $(".cookieconsent_container__more").addClass('hidden');
            $(".cookieconsent_container__mandatory").addClass('hidden');
            $(".cookieconsent_container__restrict").removeClass('hidden');
            $(".cookieconsent_container__ok").removeClass('hidden');
        } else { //ce cookie obstaja, vendar nima vseh opcij potrjenih
            $(".notice").removeClass('annoying hidden').addClass('friendly');
            $(".cookieconsent_container__more").addClass('hidden');
            $(".cookieconsent_container__mandatory").addClass('hidden');
            $(".cookieconsent_container__ok").addClass('hidden');
            $(".cookieconsent_container__restrict").removeClass('hidden');
        }
    }

    if (getBackUrl()) {
        $(".cookieconsent_container__back").removeClass('hidden');
    }
}

function setCheckboxes() {
    if (checkCookie('analiticni')) {
        $('input#analiticni').prop('checked',true);
    } else {
        $('input#analiticni').prop('checked',false);
    }

    if (checkCookie('oglasevalski')) {
        $('input#oglasevalski').prop('checked',true);
    } else {
        $('input#oglasevalski').prop('checked',false);
    }

    if (checkCookie('druzabni')) {
        $('input#druzabni').prop('checked',true);
    } else {
        $('input#druzabni').prop('checked',false);
    }
}

function getBackUrl(){
    const params = new URLSearchParams(window.location.search);
    const back = params.get("back") ? params.get("back") : '';
    return back;
}

function setSelectedCookies(){
    var data_string = '';
    var all_off = true;

    if ($('input#analiticni').is(':checked')) {
        data_string += 'analiticni=on&';
    }
    else {
        data_string += 'analiticni=off&';
    }

    if ($('input#oglasevalski').is(':checked')) {
        data_string += 'oglasevalski=on&';
    }
    else {
        data_string += 'oglasevalski=off&';
    }

    if ($('input#druzabni').is(':checked')) {
        data_string += 'druzabni=on';
    }
    else {
        data_string += 'druzabni=off';
    }

    if (data_string == 'analiticni=off&oglasevalski=off&druzabni=off') {
        data_string = 'nujni=on';
    }

    setCookieOnDomain('//www.delo.si/services/set_cookie?d=.delo.si', data_string);
    setCookieOnDomain('//www.slovenskenovice.si/services/set_cookie?d=.slovenskenovice.si', data_string);
}